'use client'

import { useRef, useEffect, useState } from 'react'
interface HeroVariant {
  id: number
  description: string
  html: string
}

interface HeroVariantProps {
  variant: HeroVariant
  onSelect: (variant: HeroVariant) => void
  isSelected?: boolean
}

export function HeroVariant({
  onSelect,
  variant,
  isSelected
}: HeroVariantProps) {
  const [isHovered, setIsHovered] = useState(false)

  const iframeRef = useRef<HTMLIFrameElement | null>(null)
  const handleClick = () => {
    onSelect(variant)
  }

  useEffect(() => {
    const iframe = iframeRef.current
    if (iframe && variant.html) {
      const doc = iframe.contentDocument || iframe.contentWindow?.document
      if (doc) {
        doc.open()
        doc.write(`
        <style>
          html, body {
            margin: 0;
            padding: 0;
            overflow: hidden;
            pointer-events: none;
          }
        </style>
        ${variant.html}
      `)
        doc.close()
      }
    }
  }, [variant.html])

  return (
    <div className='relative h-40 w-[1149px] overflow-hidden rounded-sm lg:w-[1470px]'>
      <iframe
        ref={iframeRef}
        className='h-full w-full'
        style={{
          transform: 'scale(0.25)',
          transformOrigin: 'top left',
          height: '400%',
          pointerEvents: 'none',
          border: '5px solid',
          borderColor: isHovered || isSelected ? '#ed7226' : 'white'
        }}
        title='Hero Preview'
        sandbox='allow-same-origin'
      />
      <div
        className='absolute inset-0 z-10'
        style={{ cursor: 'pointer', background: 'transparent' }}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      />
    </div>
  )
}
